import React, { useState } from 'react';
import axios from '../../axios';
import { Form, Button, Alert } from 'react-bootstrap';

const EnrollmentStatusUploadForm = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post('/enrollments/import-status', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-auth-token': localStorage.getItem('token'),
        },
      });
      alert('Status updated successfully');
      setError('');
      onUploadSuccess();
    } catch (err) {
      console.error(err);
      setError('Failed to update status');
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>Select Excel file</Form.Label>
        <Form.Control type="file" onChange={handleFileChange} required />
      </Form.Group>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button variant="primary" type="submit">
        Upload Status
      </Button>
    </Form>
  );
};

export default EnrollmentStatusUploadForm;
